import React from 'react';
type AdvisorsSvgProps = {
  stroke: string;
};

export const CommoditiesSvg: React.FC<AdvisorsSvgProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1055_3963)">
      <path
        d="M12.0698 1.3759C13.1226 1.3759 13.7946 0.967121 13.7946 0.685975C13.7946 0.40483 13.1226 -0.00395203 12.0698 -0.00395203C11.0367 -0.00395203 10.374 0.388962 10.3495 0.669762L10.3778 0.799123C10.5237 1.06509 11.1515 1.3759 12.0698 1.3759Z"
        fill={props.stroke}
      />
      <path
        d="M10.5963 1.79323L11.4135 5.51642H14.8228L13.9732 1.55486C13.5385 1.8705 12.8607 2.06678 12.07 2.06678C11.5049 2.06678 10.9989 1.96571 10.5963 1.79323Z"
        fill={props.stroke}
      />
      <path
        d="M18.2986 12.4147H14.8631L14.4388 14.4845H16.7936L17.4921 16.347L18.2986 12.4147Z"
        fill={props.stroke}
      />
      <path
        d="M19.7715 5.23476C19.3662 5.41172 18.8529 5.5159 18.2792 5.5159C17.4927 5.5159 16.8176 5.32169 16.3826 5.0088L15.8538 7.58568H19.2893L19.7715 5.23476Z"
        fill={props.stroke}
      />
      <path
        d="M18.44 11.7248L19.1479 8.27518H15.7124L15.0049 11.7248H18.44Z"
        fill={props.stroke}
      />
      <path
        d="M14.0341 17.2442H15.6258H17.0918L16.3157 15.1744H13.3442L12.568 17.2442H14.0341Z"
        fill={props.stroke}
      />
      <path
        d="M14.5838 10.345H12.4736L13.3823 14.4845H13.7345L14.5838 10.345Z"
        fill={props.stroke}
      />
      <path
        d="M12.3221 9.65503H14.7252L15.2071 7.30652L14.9708 6.2054H11.5649L12.3221 9.65503Z"
        fill={props.stroke}
      />
      <path
        d="M11.5724 17.9342H10.5844L9.80823 20.0039H14.3321L13.5559 17.9342H11.5724Z"
        fill={props.stroke}
      />
      <path
        d="M11.8309 17.2442L12.7461 14.8036L11.4645 8.9651H1.36676C1.34468 9.79095 1.24774 10.6158 1.06871 11.4216L0.0624488 15.951C0.0182935 16.1476 -0.00378418 16.3494 -0.00378418 16.5505C-0.00378418 18.0742 1.23601 19.314 2.75972 19.314H9.3299L10.1061 17.2442H11.8309ZM8.96527 14.4845C8.96527 15.437 8.1929 16.2093 7.24045 16.2093H6.55052V18.2791H6.20556H5.8606H5.17067C4.21823 18.2791 3.44585 17.5067 3.44585 16.5543V16.2093H4.48074C5.04752 16.2093 5.54633 16.4867 5.8606 16.9086V14.1396H5.17067C4.21823 14.1396 3.44585 13.3672 3.44585 12.4147V12.0698H4.48074C5.04752 12.0698 5.54633 12.3471 5.8606 12.769V12.0698V11.7248C5.8606 10.7724 6.63297 9.99999 7.58541 9.99999H8.62031V10.345C8.62031 11.2974 7.84793 12.0698 6.89549 12.0698H6.55052V14.8388C6.86479 14.4169 7.3636 14.1396 7.93038 14.1396H8.96527V14.4845Z"
        fill={props.stroke}
      />
      <path
        d="M18.0873 17.9342H16.1038L15.3276 20.0039H19.8515L19.0753 17.9342H18.0873Z"
        fill={props.stroke}
      />
      <path
        d="M0.341179 8.27518H11.3131L11.0102 6.89532H0.341179C0.15076 6.89532 -0.00378418 7.04987 -0.00378418 7.24029V7.93022C-0.00378418 8.12064 0.15076 8.27518 0.341179 8.27518Z"
        fill={props.stroke}
      />
      <path
        d="M14.2928 17.9342L14.83 19.3661L15.3671 17.9342H14.2928Z"
        fill={props.stroke}
      />
      <path
        d="M10.4402 4.3005L9.72026 4.1977C9.30182 4.13768 8.96548 3.83377 8.86303 3.42395L8.76126 3.01655C8.72263 2.86338 8.58499 2.75575 8.4263 2.75575H8.01166C7.61702 2.75575 7.2624 2.53636 7.08577 2.18381L6.77703 1.56667C6.71873 1.44903 6.60076 1.3759 6.46898 1.3759H5.34612C5.19296 1.3759 5.05635 1.4787 5.01461 1.626L4.57685 3.15729C4.47543 3.51157 4.19015 3.78754 3.83277 3.87689L3.24081 4.02488C3.11697 4.05592 3.02072 4.15182 2.99002 4.27601L2.87584 4.73171C2.76097 5.19292 2.3477 5.51546 1.87199 5.51546H1.56981C1.41112 5.51546 1.27383 5.62309 1.23485 5.77695L1.12756 6.20539H10.8583L10.4402 4.3005ZM4.13565 5.51546H3.44572V4.82554H4.13565V5.51546ZM6.20543 2.75575H5.5155V2.06583H6.20543V2.75575ZM7.24032 4.48057H6.55039V3.79065H7.24032V4.48057ZM9.3101 5.51546H8.62017V4.82554H9.3101V5.51546Z"
        fill={props.stroke}
      />
      <path
        d="M18.2793 3.44568C17.2264 3.44568 16.5544 3.85446 16.5544 4.13561C16.5544 4.41675 17.2264 4.82553 18.2793 4.82553C19.2183 4.82553 19.8509 4.50092 19.9772 4.23116L19.9999 4.12077C19.9779 3.84032 19.3145 3.44568 18.2793 3.44568Z"
        fill={props.stroke}
      />
    </g>
    <defs>
      <clipPath id="clip0_1055_3963">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
